import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

function Breadcrumbs() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const pathSetting = () => {
    if (location.pathname === "/home/role-management") {
      return { parent: "Access Management", child: "Manage" };
    }
    if (location.pathname === "/home/search") {
      return { parent: "Video Finder", child: "Search" };
    }
    if (location.pathname === "/home/replace-search") {
      return { parent: "Video Finder", child: "Replace - Search" };
    }
    if (location.pathname === "/home/videos") {
      return { parent: "Video Finder", child: "Videos" };
    }
    if (location.pathname === "/home/settings") {
      return { parent: "Video Finder", child: "Settings" };
    }
    if (location.pathname === "/home/course-content-all") {
      return { parent: "Course Content", child: "All" };
    }
    if (location.pathname === "/home/course-contents-video") {
      return { parent: "Course Content", child: "Video" };
    }
    if (location.pathname === "/home/course-contents-web") {
      return { parent: "Course Content", child: "Web" };
    }
    if (location.pathname === "/home/assignment-content-all") {
      return { parent: "Assignment Content", child: "All" };
    }
    if (location.pathname === "/home/assignment-content-video") {
      return { parent: "Assignment Content", child: "Video" };
    }
    if (location.pathname === "/home/assignment-content-web") {
      return { parent: "Assignment Content", child: "Web" };
    }
    if (location.pathname === "/home/summary-generation") {
      return { parent: "Video Finder", child: "Summary Generation" };
    }
    if (location.pathname === "/home/transcript-generation") {
      return { parent: "Video Finder", child: "Transcript Generation" };
    }
    if (location.pathname === "/home/scribe-content-generate") {
      return { parent: "Scribe Bot", child: "Generate" };
    }
    if (location.pathname === "/home/scribe-contents") {
      return { parent: "Scribe Bot", child: "Generated Contents" };
    }
    if (location.pathname === "/home/scribe-settings") {
      return { parent: "Scribe Bot", child: "Settings" };
    }
    if (location.pathname === "/home/pinging-video") {
      const value = searchParams.get("value") || "all";
      const childLabels = {
        good_video: "Good",
        bad_video: "Bad",
        all: "All",
        downloaded: "Downloaded",
        not_downloaded: "Not Downloaded",
        replaced: "Replaced Backup Video",
      };
      return { parent: "Pinging Video", child: childLabels[value] || "All" };
    }

    if (location.pathname === "/home/pinging-web") {
      const value = searchParams.get("value") || "web_all";
      const childLabels = {
        good_web: "Good",
        bad_web: "Bad",
        web_all: "All",
      };
      return { parent: "Pinging Web", child: childLabels[value] || "All" };
    }
    if (location.pathname === "/home/assign-pinging-video") {
      const value = searchParams.get("value") || "all";
      const childLabels = {
        good_video: "Good",
        bad_video: "Bad",
        all: "All",
        downloaded: "Downloaded",
        not_downloaded: "Not Downloaded",
      };
      return { parent: "Assign Pinging - Video", child: childLabels[value] || "All" };
    }
    if (location.pathname === "/home/assign-pinging-web") {
      const value = searchParams.get("value") || "all";
      const childLabels = {
        good_web: "Good",
        bad_web: "Bad",
        all: "All",
      };
      return { parent: "Assign Pinging - Web", child: childLabels[value] || "All" };
    }
    if (location.pathname === "/home/assignment-content") {
      const value = searchParams.get("value") || "all";
      const childLabels = {
        video: "Video",
        web: "Web",
        all: "All",
      };
      return { parent: "Assignment Content", child: childLabels[value] || "All" };
    }
    if (location.pathname === "/home/course-content") {
      const value = searchParams.get("value") || "all";
      const childLabels = {
        video: "Video",
        web: "Web",
        all: "All",
      };
      return { parent: "Course Content", child: childLabels[value] || "All" };
    }
    if (location.pathname === "/home/standards-wizard") {
      return { parent: "Standards Wizard", child: "Create Course" };
    }
    if (location.pathname === "/home/saved-courses") {
      return { parent: "Standards Wizard", child: "Saved Courses" };
    }
  };
  let pathObj = pathSetting() || { parent: "Home", child: "Dashboard" };
  return (
    <Breadcrumb>
      <Breadcrumb.Item onClick={() => navigate("/home")}>Home</Breadcrumb.Item>
      <Breadcrumb.Item className="breadcrumb-no-link">{pathObj.parent}</Breadcrumb.Item>
      <Breadcrumb.Item className="breadcrumb-no-link" active>
        {pathObj.child}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}

export default Breadcrumbs;
